import styled from "@emotion/styled"
import { spacingFluidXs } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const OverviewSummaryImagesSkeleton = () => (
	<Wrapper>
		<StyledSkeletonPicture />
		<Skeleton.Picture />
		<Skeleton.Picture />
		<Skeleton.Picture />
	</Wrapper>
)

const Wrapper = styled.div`
	display: grid;
	gap: ${spacingFluidXs};
	grid-template-columns: repeat(3, minmax(0, 1fr));
`

const StyledSkeletonPicture = styled(Skeleton.Picture)`
	grid-column: 1 / -1;
`
